import { useEffect, useState } from "react";
import { TopBar } from "../components/TopBar";
import { TabBar } from "../components/TabBar";
import { api } from "../api/client";
import type { BodyWeightEntry } from "../api/types";

export const BodyWeight = () => {
  const [items, setItems] = useState<BodyWeightEntry[]>([]);
  const [weight, setWeight] = useState("");
  const [notes, setNotes] = useState("");

  const load = async () => {
    const data = await api<BodyWeightEntry[]>("/bodyweight");
    setItems(data);
  };

  useEffect(() => {
    void load();
  }, []);

  const add = async () => {
    if (!weight) return;
    await api("/bodyweight", {
      method: "POST",
      body: { weight: Number(weight), notes },
    });
    setWeight("");
    setNotes("");
    await load();
  };

  // Mini bar chart over the last 12 entries
  const last = items.slice(0, 12).reverse();
  const max = Math.max(...last.map((b) => b.weight), 1);

  return (
    <>
      <div className="page">
        <TopBar title="Body weight" back />

        <div className="card">
          <label className="field">
            Weight
            <input
              inputMode="decimal"
              placeholder="e.g. 180"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
            />
          </label>
          <label className="field" style={{ marginTop: 8 }}>
            Note
            <input value={notes} onChange={(e) => setNotes(e.target.value)} />
          </label>
          <button className="btn" style={{ marginTop: 12 }} onClick={() => void add()}>
            Log today
          </button>
        </div>

        {last.length > 0 && (
          <>
            <h2 className="h2">Recent</h2>
            <div className="card">
              <div className="bar-chart">
                {last.map((b, i) => (
                  <div
                    key={i}
                    className="bar"
                    style={{ height: `${(b.weight / max) * 100}%` }}
                    title={`${b.date}: ${b.weight} ${b.units}`}
                  />
                ))}
              </div>
            </div>
          </>
        )}

        <h2 className="h2">History</h2>
        {items.map((b) => (
          <div className="card" key={b.date}>
            <div className="row">
              <strong>{b.date}</strong>
              <div className="spacer" />
              <span>{b.weight} {b.units}</span>
            </div>
            {b.notes && <div className="muted" style={{ marginTop: 4 }}>{b.notes}</div>}
          </div>
        ))}
      </div>
      <TabBar />
    </>
  );
};
